import { CurrencyEnum, LocaleEnum, Popover, centsToUnits, units } from '@systemeio/ui'
import { AffiliateSumType } from 'modules/affiliate-program/affiliate/types/affiliate-interface'
import React from 'react'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { currencyFormat } from 'shared/utils/currency-format'

export const getAffiliateSum = (
  amountObj: AffiliateSumType,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
) =>
  selectedCurrency
    ? currencyFormat(centsToUnits(amountObj[selectedCurrency]), selectedCurrency, locale)
    : currencyFormat(units(0), CurrencyEnum.EURO, locale)

export const getAffiliateTotalSum = (
  amountObj: AffiliateSumType,
  t: TLocoType,
  selectedCurrency?: CurrencyEnum,
  locale?: LocaleEnum,
) => (
  <div className={'flex items-center gap-1.5'}>
    {getAffiliateSum(amountObj, selectedCurrency, locale)}
    {Object.keys(amountObj).length > 1 && (
      <Popover
        label={
          <div className={'text-text-primary flex flex-col gap-1 font-bold'}>
            {(Object.keys(amountObj) as CurrencyEnum[])
              .filter(cur => cur !== selectedCurrency)
              .map(cur => (
                <span key={cur}>{getAffiliateSum(amountObj, cur, locale)}</span>
              ))}
          </div>
        }
        popoverClassName={'max-w-[200px] sm:max-w-[350px]'}
      >
        {show => (
          <span
            className={`${
              show ? 'bg-brand-primary' : 'bg-fill-primary'
            } group-focus-visible:fill-brand-primary text-background-secondary rounded-lg px-1 outline-hidden`}
          >
            {t('global.more').toLowerCase()}
          </span>
        )}
      </Popover>
    )}
  </div>
)
